import { z } from 'zod';
import { nameSchema, dateSchema, timeSchema, optionalTextSchema } from './formSchemas';

/**
 * Zod schema for Event form validation
 * Messages updated to use translation keys
 */
export const eventSchema = z.object({
    eventName: nameSchema,
    eventDate: dateSchema,
    eventTime: timeSchema,
    eventLocation: optionalTextSchema,
    eventDescription: optionalTextSchema,
    category: z.union([
        z.enum([
            "Birthday",
            "Wedding",
            "Anniversary",
            "Graduation",
            "New Born",
            "Engagement",
            "Holiday",
            "Cultural",
            "Seasonal",
            "Professional"
        ]),
        z.literal("")
    ]).refine((val) => val !== "" && val !== null && val !== undefined, {
        message: "errors.eventTypeRequired"
    }),
    eventImage: z.string().optional().nullable()
});

// Type inference for TypeScript (can be used with JSDoc in JavaScript)
// export type EventFormData = z.infer<typeof eventSchema>;
